import shipvistaAPI from "./shipvistaAPI";

export const getUser = (accessToken: string) => {
  return shipvistaAPI.get("/User", {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
};
